import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import getToken from 'helpers/auth';
import { history } from 'helpers/history';
import Swal from 'sweetalert2';

// Shared layouts
import { Dashboard as DashboardLayout } from 'layouts';

import {
  Portlet,
  PortletHeader,
  PortletLabel,
  PortletContent,
} from 'components';

// Material helpers
import { makeStyles } from '@mui/styles';

// Material components
import { Button, Grid2, TextField } from '@mui/material';

import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

// Component styles
import styles from './styles';
import { useParams } from 'react-router-dom';

const useStyles = makeStyles(styles);

export default function NewPowerFactor() {
  const { register, handleSubmit } = useForm();
  const classes = useStyles();
  const dispatch = useDispatch();
  const { meterId } = useParams();
  const { fpId } = useParams();
  const user = useSelector((state) => state.user.user);
  const corpAdmin = useSelector((state) => state.user.corporative);
  const corpUser = user.corporative;
  const corporativeId =
    corpUser === undefined || corpUser === null ? corpAdmin.id : corpUser.id;
  const [cards, setCards] = useState([]);
  const [controlCard, setControlCard] = useState(null);
  const [ade, setAde] = useState(1);
  const [name, setName] = useState(null);
  const [description, setDescription] = useState(null);

  useEffect(() => {
    if (fpId) {
      getFP();
    }
    getCards();
  }, [fpId]);

  const onSubmit = (values) => {
    if (fpId) {
      dispatch(putFPData(values));
    } else {
      dispatch(postFPData(values));
    }
  };

  const handleControlCard = (card) => {
    setControlCard(card.target.value);
  };

  const handleAde = (ade) => {
    setAde(ade.target.value);
  };

  const getCards = async () => {
    try {
      const response = await axios.get(
        `https://api.metimur.mx/api/corporative/${corporativeId}/meter/${meterId}/cards`,
        { headers: { Authorization: 'Bearer ' + getToken() } }
      );
      setCards(response.data.data);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const getFP = async () => {
    try {
      const response = await axios.get(
        `https://api.metimur.mx/api/fp/${fpId}`,
        { headers: { Authorization: 'Bearer ' + getToken() } }
      );
      setFPValues(response.data.data);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const setFPValues = (data) => {
    setName(data.name);
    setDescription(data.description);
    setAde(data.ade);
    setControlCard(data.card_id);
  };

  const postFPData = (values) => {
    return async () => {
      axios
        .post(
          'https://api.metimur.mx/api/fp',
          {
            name: values.name,
            description: values.description,
            card_id: values.card_id,
            meter_id: meterId,
            ade: parseInt(values.ade),
          },
          {
            headers: { Authorization: 'Bearer ' + getToken() },
          }
        )
        .then(() => {})
        .then(() => {
          Swal.fire({
            title: 'FP Creado',
            text: 'FP creado exitosamente',
            icon: 'success',
          }).then(() => {
            history.push(`/powerfactor/${meterId}`);
            window.location.href = `/powerfactor/${meterId}`;
          });
        })
        .catch((error) => {
          const errorMessage = error.response.data.message;

          Swal.fire({
            title: 'Error',
            text: `${errorMessage.join('<br/>')}`,
            icon: 'error',
          });
        });
    };
  };

  const putFPData = (values) => {
    return async () => {
      axios
        .put(
          'https://api.metimur.mx/api/fp',
          {
            id: fpId,
            name: values.name,
            description: values.description,
            card_id: values.card_id,
            meter_id: meterId,
            ade: parseInt(values.ade),
          },
          {
            headers: { Authorization: 'Bearer ' + getToken() },
          }
        )
        .then(() => {})
        .then(() => {
          Swal.fire({
            title: 'FP Modificado',
            text: 'FP modificado exitosamente',
            icon: 'success',
          }).then(() => {
            history.push(`/powerfactor/${meterId}`);
            window.location.href = `/powerfactor/${meterId}`;
          });
        })
        .catch((error) => {
          const errorMessage = error.response.data.message;

          Swal.fire({
            title: 'Error',
            text: `${errorMessage.join('<br/>')}`,
            icon: 'error',
          });
        });
    };
  };

  const handleChangeName = (event) => {
    setName(event.target.value);
  };

  const handleChangeDescription = (event) => {
    setDescription(event.target.value);
  };

  return (
    <DashboardLayout title="Creacion Factor de Potencia">
      <div className={classes.root}>
        <Portlet>
          <PortletHeader>
            <PortletLabel title="Factor de Potencia" />
          </PortletHeader>
          <PortletContent noPadding={true}>
            <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
              <Grid2 container={true} spacing={4}>
                <Grid2 size={12}>
                  <div className={classes.fields}>
                    <TextField
                      className={classes.textField}
                      {...register('name')}
                      label="Nombre"
                      name="name"
                      onChange={handleChangeName}
                      required
                      value={name}
                      variant="filled"
                    />
                    <TextField
                      className={classes.textField}
                      {...register('description')}
                      label="Descripción"
                      name="description"
                      onChange={handleChangeDescription}
                      required
                      value={description}
                      variant="filled"
                    />
                    <FormControl
                      className={classes.textField}
                      variant="outlined"
                    >
                      <InputLabel id="demo-simple-select-outlined-label">
                        Tarjeta de Control
                      </InputLabel>
                      <Select
                        id="demo-simple-select-outlined"
                        {...register('card_id')}
                        labelId="demo-simple-select-outlined-label"
                        name="card_id"
                        onChange={handleControlCard}
                        value={controlCard}
                      >
                        {cards?.map((card, index) => (
                          <MenuItem value={card.id} key={index}>
                            {card.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <FormControl
                      className={classes.textField}
                      variant="outlined"
                    >
                      <InputLabel id="demo-simple-select-outlined-label">
                        ADE
                      </InputLabel>
                      <Select
                        id="demo-simple-select-outlined"
                        {...register('ade')}
                        labelId="demo-simple-select-outlined-label"
                        name="ade"
                        onChange={handleAde}
                        value={ade}
                      >
                        <MenuItem value={1}>ADE1</MenuItem>
                        <MenuItem value={2}>ADE2</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </Grid2>
              </Grid2>

              <Button
                className={classes.signUpButton}
                color="secondary"
                size="large"
                type="submit"
                variant="contained"
              >
                Guardar
              </Button>
            </form>
          </PortletContent>
        </Portlet>
      </div>
    </DashboardLayout>
  );
}
